import { ModelTransformer } from '../common/common.model';

// TODO move
/**
 * treats all string dates as utc unless the map key value is 'L'
 */
export class ObjectDateTransformer<TIn> implements ModelTransformer<TIn, TIn> {
    constructor(private readonly _map: any) {}

    transform(model: TIn): TIn {
        if (!model) {
            return null;
        }
        this._transform(model, this._map);
        return model;
    }

    private _transform(model: any, map: any): void {
        if (!model) {
            return;
        }
        if (Array.isArray(model)) {
            model.forEach((e) => this._transform(e, map));
        } else {
            const realKeys = Object.keys(map);
            Object.entries(model)
                // eslint-disable-next-line @typescript-eslint/prefer-includes
                .filter(([key]) => realKeys.indexOf(key) !== -1)
                .forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        this._transform(value, map[key]);
                    }
                    if (typeof value === 'string') {
                        if (value.endsWith('Z')) {
                            value = value.substring(0, value.length - 1);
                        }
                        const z = map[key] === 'L' ? '' : ('Z' as string);
                        // const d = new Date(`${value}${z}`);
                        // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
                        model[key] = new Date(`${value}${z}`); // new Date(d.setHours(0, 0, 0));
                    }
                });
            Object.entries(model)
                .filter(
                    ([key]) =>
                        this._map[key] != null &&
                        typeof this._map[key] === 'object',
                )
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
                .forEach(([key]) =>
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
                    this._transform(model[key], this._map[key] as any),
                );
        }
    }
}
